import { useEffect, useState } from "react";
import s2rService from "../../../common/services/s2r-service";
import { useSelector, useDispatch } from "react-redux";
import profileThunks from "../../Profile/redux/thunks";

const useFreeUserImageCount = () => {
  const dispatch = useDispatch();
  const authUser = useSelector((state) => state.session.authUser);
  const user = useSelector((state) => state.profile.user);

  const [freeUserCanRender, setfreeUserCanRender] = useState(true);

  // check for free user image count on first render
  useEffect(() => {
    if (!user && authUser) {
      dispatch(profileThunks.getProfileAsync(authUser.uid)).then((user) => {
        if (user?.membership === "free") {
          getImageCount(user).then((res) => {
            const count = res.data;
            if (count >= 30) {
              setfreeUserCanRender(false);
            }
          });
        }
      });
    }
  }, []);

  const getImageCount = async (user) => {
    return new Promise(async (resolve, reject) => {
      try {
        const imageCount = await s2rService.getImageCount(user.uuid);
        resolve(imageCount);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  };

  return [freeUserCanRender];
};
export default useFreeUserImageCount;
